/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});
	// Prevent Dropdown buttons in Main Nav from doing anything when clicked
	const dropdownLinks = document.querySelectorAll('.menu-item a[href="#"]');
	for (const dropdownLink of dropdownLinks) {
		dropdownLink.addEventListener('click', (event) => {
			event.preventDefault();
		});
	}

	// Show and play audio sample
	const playButton = document.querySelector('.show-audio-btn');
	const audioControls = document.querySelector('.controls-container');
	const audioElement = document.querySelector('audio.audio-sample-controls');

	playButton.addEventListener('click', (event) => {
		// Show the audio controls
		audioControls.style.visibility = 'visible';
		
		// Start playing the audio
		try {
			const playPromise = audioElement.play();
			
			if (playPromise !== undefined) {
				playPromise
					.then(() => {
						// Playback started successfully
						// Move focus to the audio controls
						audioElement.focus();
					})
					.catch(error => {
						console.error('Playback failed:', error);
						// Still move focus even if autoplay fails
						audioElement.focus();
					});
			}
		} catch (error) {
			console.error('Error playing audio:', error);
			// Still move focus even if there's an error
			audioElement.focus();
		}
		event.preventDefault();
	});


	// home page product carousel
	const productSpin = document.querySelector('.product-spin');
	if (productSpin) {
		const icons = document.querySelectorAll('.product-icons');
		const nameElement = document.querySelector('.product-spin-name');
		let currentlyActive = 0;
		let rotationInterval;
		
		function updatePositions(newActive) {
		currentlyActive = newActive;
		icons.forEach((icon, index) => {
			let newPos = (currentlyActive - index + icons.length) % icons.length;
			icon.classList.remove(...Array.from({length: 5}, (_, i) => `position${i}`));
			icon.classList.add(`position${newPos}`);
			icon.classList.toggle('active', newPos === 0);
			icon.classList.toggle('inactive', newPos !== 0);
		});
		nameElement.textContent = icons[currentlyActive].querySelector('img').alt;
		}
		
		function rotate() {
		updatePositions((currentlyActive + 1) % icons.length);
		}
		
		// Add click handlers
		icons.forEach((icon, index) => {
		icon.addEventListener('click', () => {
			clearInterval(rotationInterval);
			updatePositions(index);
			// rotationInterval = setInterval(rotate, 3000);
		});
		}); 
		
		// Start initial rotation
		rotationInterval = setInterval(rotate, 3000);
	}


	// AI Voice Accordion
	let activeImg = document.querySelector('.aivoice-accordion .kt-accordion-panel-active .accordion-img-con');
	let highlightBox = document.querySelector('.accordion-highlight > .kt-inside-inner-col');
	let accordionBtns = document.querySelectorAll('.aivoice-accordion .kt-acccordion-button-label-show');
	let lastClicked;
	accordionBtns.forEach((accordionBtn) => {
		accordionBtn.addEventListener('click', function(){
			accordionBtn.disabled = true;
			if(lastClicked !== accordionBtn){
				if(lastClicked) {
					let highlightImg = highlightBox.querySelector('.accordion-img-con');
					let lastClickedCon = lastClicked.parentElement.nextElementSibling;
					lastClickedCon.appendChild(highlightImg);
				}
				let accordionContent = accordionBtn.parentElement.nextElementSibling;
				let activeImgCon = accordionContent.querySelector('.accordion-img-con');
				lastClicked = accordionBtn;
				highlightBox.appendChild(activeImgCon);
			} else if (lastClicked === accordionBtn) {
				let highlightImg = highlightBox.querySelector('.accordion-img-con');
				let lastClickedCon = lastClicked.parentElement.nextElementSibling;
				lastClickedCon.appendChild(highlightImg);
				lastClicked = undefined;
			}
			setTimeout(() => {
				accordionBtn.disabled = false;
			}, 500);
		});
	})
	
  


}); 

// Sticky footer CTA
document.addEventListener('DOMContentLoaded', function() {
    const stickyElement = document.querySelector('.sticky-element');
    const footer = document.querySelector('footer');

    function updateStickyPosition() {
        const viewportHeight = window.innerHeight;
        const scrollY = window.scrollY || window.pageYOffset;
        const footerTop = footer.getBoundingClientRect().top + scrollY;
        const stickyBottom = scrollY + viewportHeight;
        
        if (stickyBottom > footerTop) {
            stickyElement.style.position = 'absolute';
        } else {
            stickyElement.style.position = 'fixed';
        }
    }

    window.addEventListener('scroll', updateStickyPosition);
    window.addEventListener('resize', updateStickyPosition);
    updateStickyPosition();
});